module.exports = __webpack_public_path__ + "img/fail-08.1639b486.svg";